module.exports = __webpack_public_path__ + "assets/img/signup.f58dadee.jpg";